import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import PointOperationChartNew from "./PointOperationChartNew";
import { getParsedPointOperationChartData } from "./PointOperationChartUtils";

import "./PointOprationChart.scss";

type LocationStateType = { state?: any };

const PointOperationChartWrapper = () => {
  const location = useLocation();
  const locationState = location?.state as LocationStateType;
  const navigate = useNavigate();
  const {
    machineData = { eventData: [], eventTime: [] },
    deviceId,
    deviceName,
    currentTs,
    disableFilter,
  } = locationState?.state ?? {};

  const initial_data = useMemo(() => {
    const raw_data = {
      EVENTDATA1: [{ ts: currentTs, value: machineData?.eventData }],
      EVENTTIME: [{ ts: currentTs, value: machineData?.eventTime }],
    };

    return getParsedPointOperationChartData(raw_data);
  }, [machineData, currentTs]);

  useEffect(() => {
    if (!locationState?.state) {
      navigate("/telemetry");
    }
  }, []);

  if (!locationState?.state) {
    return <></>;
  }

  return (
    <div className="point-operation-chart--wrapper">
      <PointOperationChartNew
        initial_data={initial_data}
        deviceId={deviceId}
        deviceName={deviceName}
        disableFilter={disableFilter}
      />
    </div>
  );
};

export default PointOperationChartWrapper;
